import { ShieldCheck, Wrench, Clock, BadgeCheck } from "lucide-react";

const WhyChooseUs = () => {
    const features = [
        {
            icon: <ShieldCheck size={40} className="wcu-hob-icon" />,
            title: "Trusted & Verified",
            desc: "Our technicians are background-verified and trained to deliver the highest standards."
        },
        {
            icon: <Wrench size={40} className="wcu-hob-icon" />,
            title: "Expert Technicians",
            desc: "Skilled professionals drivers with years of hands-on experience in Ambulance."
        },
        {
            icon: <Clock size={40} className="wcu-hob-icon" />,
            title: "On-Time Service",
            desc: "We value your time and ensure punctual, efficient service every time."
        },
        {
            icon: <BadgeCheck size={40} className="wcu-hob-icon" />,
            title: "Strong  Network",
            desc: "Royal Ambulance ensures quick arrival within 15 minutes anywhere in Mumbai. "
        }
    ];

    return (
        <section className="wcu-hob-section">
            <div className="wcu-hob-container">
                <h2 className="wcu-hob-title">Why Choose Us</h2>
                <p className="wcu-hob-subtitle">Roayl Ambulance trusted for the speed</p>
                <div className="wcu-hob-grid">
                    {features.map((item, index) => (
                        <div className="wcu-hob-card" key={index}>
                            <div className="wcu-hob-icon-wrapper">{item.icon}</div>
                            <h3 className="wcu-hob-card-title">{item.title}</h3>
                            <p className="wcu-hob-card-desc">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
